import { useAuth } from "../providers/Auth";

export const EhrSources = {
  OULA_NYC_ATHENA: "OULA_NYC_ATHENA",
  STAMFORD_HEALTH_EPIC: "STAMFORD_HEALTH_EPIC",
  NOVANT_HEALTH_EPIC: "NOVANT_HEALTH_EPIC",
};

export const usePatientEhrSource = () => {
  const { user, loading } = useAuth();
  const ehrSource = user?.accountRegistrationState?.ehrSourceCode;

  return { ehrSource, isLoading: loading };
};
